import { RootState } from '@/store/types'
import {
  WorkOvertimeApplicationsState, WorkOvertimeApplication,
} from '@/store/applications/workOvertime/types'
import axios from 'axios'
import { ActionTree } from 'vuex'
import _ from 'lodash'
import moment from 'moment'

const actions: ActionTree<WorkOvertimeApplicationsState, RootState> = {
  /**
   * 時間外休日勤務申請取得
   *
   * @param {string} applicationId 申請ID
   */
  getWorkOvertimeApplication: (
    { commit, dispatch, getters },
    { applicationId }: { applicationId: string },
  ) => axios.get(`/applications/workOvertime/${applicationId}`).then(async ({ data }) => {
    await Promise.all([
      dispatch('fetchMasterCampuses'),
      ...[
        data.tutorId,
      ].map((tutorId: number) => dispatch('getTutor', { tutorId })),
    ])

    const application: WorkOvertimeApplication = {
      id: applicationId,
      type: 'workOvertime',
      targetTutor: getters.findTutorById(data.tutorId),
      date: moment(data.date, 'YYYYMMDD'),
      campus: getters.findCampusByCode(data.campusCode),
      comment: data.comment || null,
      applicant: {
        id: data.applicantId,
        name: data.applicantName,
      },
      status: data.status,
      approvedComment: _(data.events).maxBy('date')?.comment || null,
    }
    commit('gotWorkOvertimeApplication', application)
  }),

  /**
   * 時間外休日勤務申請登録
   * @param context
   * @param {WorkOvertimeApplication} payload 申請内容
   */
  registerWorkOvertimeApplication: (
    context,
    {
      targetTutor,
      campus,
      date,
      comment,
    }: WorkOvertimeApplication,
  ) => axios.post('/applications/workOvertime', {
    tutorId: targetTutor.id,
    campusCode: campus.code,
    date: moment(date).format('YYYYMMDD'),
    comment,
  }),
}

export default actions
